import type { RouteObject } from "react-router-dom";
import ContactPage from "@/pages/contact/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <ContactPage />,
  },
  {
    path: "*",
    element: <ContactPage />,
  },
];

export default routes;
